// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__D6r8+","button":"styles_button__rGpQa","loading":"styles_loading__diWL9","icon":"styles_icon__lCiDn"};